export interface CheckoutPriceCalculation {
  paidAttendeeCount: number;
  waitlistedAttendeeCount: number;
  baseAmount: number;
  voucherDiscount: number;
  codeDiscount: number;
  adminDiscount: number;
  total: number;
}

// Minimal interface for price calculation - only needs what we actually use
export interface PricingAttendee {
  isSelected: boolean;
  isWaitlist: boolean;
}

export function calculateCheckoutPrice<T extends PricingAttendee>(
  attendees: T[],
  eventPrice: number,
  voucherQuantity: number,
  codeDiscountAmount: number,
  adminDiscountAmount: number,
): CheckoutPriceCalculation {
  const paidAttendees = attendees.filter((a) => a.isSelected && !a.isWaitlist);
  const waitlistedAttendees = attendees.filter(
    (a) => a.isSelected && a.isWaitlist,
  );

  const paidAttendeeCount = paidAttendees.length;
  const waitlistedAttendeeCount = waitlistedAttendees.length;

  const baseAmount = paidAttendeeCount * eventPrice;
  const voucherDiscount =
    Math.min(voucherQuantity, paidAttendeeCount) * eventPrice;
  const total = Math.max(
    0,
    baseAmount - voucherDiscount - codeDiscountAmount - adminDiscountAmount,
  );

  return {
    paidAttendeeCount,
    waitlistedAttendeeCount,
    baseAmount,
    voucherDiscount,
    codeDiscount: codeDiscountAmount,
    adminDiscount: adminDiscountAmount,
    total,
  };
}
